export interface UserEquipmentsType {
  title: string;
  category: string;
  subcategory: string;
  standardServices: string;
  customServices: string;
  makers: string;
}

export enum MatchingType {
  STANDARD_SERVICE = 'STANDARD_SERVICE',
  MAKER = 'MAKER',
  EQUIPMENT = 'EQUIPMENT',
  PARENT_EQUIPMENT = 'PARENT_EQUIPMENT',
}

export interface StandardServiceType {
  title: string;
  matching: MatchingType[];
}

interface EquipmentStructureItemType {
  title: string;
  hasMaker: boolean;
  hasType: boolean;
  makers?: string[];
  standardServices: StandardServiceType[];
}

export interface EquipmentStructureType {
  title: string;
  items: Array<
    EquipmentStructureItemType & {
      items: EquipmentStructureItemType[];
    }
  >;
}

// ShipEdit
export interface TreeShipEditItemType {
  maker?: string;
  type?: string;
  description?: string;
  attachments?: string[];
}

export interface EquipmentsShipEditType {
  [key: string]: TreeShipEditItemType;
}

// ShipView
export interface TreeShipViewItemInfoType {
  title: string;
  maker?: string;
  type?: string;
  description?: string;
}

export interface TreeShipViewItemType {
  title: string;
  items: Array<
    TreeShipViewItemInfoType & {
      items?: TreeShipViewItemInfoType[];
    }
  >;
}

// SupplierEdit
export interface TreeSupplierEditItemInfoType {
  standardServices: string[];
  customServices: string[];
  makers: string[];
}

export interface EquipmentsSupplierEditType {
  [key: string]: TreeSupplierEditItemInfoType;
}

// SupplierView
export interface TreeSupplierViewItemInfoType {
  title: string;
  standardServices: string[];
  customServices: string[];
  makers: string[];
}

export interface TreeSupplierViewItemType {
  title: string;
  items: Array<
    TreeSupplierViewItemInfoType & {
      items?: TreeSupplierViewItemInfoType[];
    }
  >;
}
